import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";

type GoogleCalendarIconProps = {
  size: number;
  padding: number;
  borderRadius?: number;
};

const GoogleCalendarIcon = (props: GoogleCalendarIconProps) => {
  const { size, padding, borderRadius = 10 } = props;

  return (
    <div
      className="Centering"
      style={{
        borderRadius: borderRadius,
        padding: padding,
        backgroundColor: Colors.WHITE,
        border: `1px solid ${Colors.GRAY4}`,
      }}
    >
      <Icon icon="logos:google-calendar" height={size} />
    </div>
  );
};

export default GoogleCalendarIcon;
